import { IconName } from '@usealloy/component-library';

export const ENTITY_TYPES = {
  person: 'person',
  business: 'business',
  group: 'group',
  entity_group: 'entity_group',
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

export const ENTITY_ICON_MAP: Record<EntityType, IconName> = {
  [ENTITY_TYPES.person]: IconName.Person,
  [ENTITY_TYPES.business]: IconName.Business,
  [ENTITY_TYPES.group]: IconName.Group,
  [ENTITY_TYPES.entity_group]: IconName.CustomGroup,
};

export const TOOLTIP_TEXT: Record<EntityType, string> = {
  person: 'Person',
  business: 'Business',
  group: 'Group',
  entity_group: 'Entity Group',
};

